import { render, staticRenderFns } from "./editCompany.vue?vue&type=template&id=447c1acc&"
import script from "./editCompany.vue?vue&type=script&lang=js&"
export * from "./editCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports